import axios from 'axios';
import { plato_api_image_models_path } from '@/modules/routes';
import IImage from '@/components/interfaces/Image';
import IImageModel from '@/components/interfaces/ImageModel';
import { ImageModelType } from '@/components/admin/ImageManager/ExistingImagePicker/types';

type ApiImageModel = IImageModel & {
  image: IImage & { fileName: string, smallUrl: string };
  snippet: string;
};

type ApiResponse = { data: ApiImageModel[] };

const toPickerImageModel = (imageModel: ApiImageModel): ImageModelType => ({
  captionEn: imageModel.caption_en,
  hideCaptions: imageModel.hide_captions,
  id: imageModel.id,
  image: {
    descriptionEn: imageModel.image.description_en,
    fileName: imageModel.image.fileName || '',
    id: imageModel.image.id,
    imageUrl: imageModel.image.imageUrl,
    smallUrl: imageModel.image.smallUrl,
  },
  snippet: imageModel.snippet,
});

// AIDEV-NOTE: PLAT-17696 — scoped to this reference material on purpose. The section builder's picker
// spans the whole lesson (section + slideshows); an author reusing a reference material image only
// ever wants the ones already uploaded here.
const fetchExistingImages = (referenceMaterialId: number | string): Promise<ImageModelType[]> => {
  const params = { for_model: { model_id: referenceMaterialId, model_type: 'ReferenceMaterial' } };

  return axios
    .get<ApiResponse>(plato_api_image_models_path(params))
    .then(({ data }) => (
      data.data
        .map(toPickerImageModel)
        .sort((a, b) => a.image.fileName.localeCompare(b.image.fileName))
    ));
};

export default fetchExistingImages;
